export default __webpack_public_path__ + "static/media/instagram.c1b9268e.svg";